<template>
<div class="query-header">
  <el-row
    :gutter="20"
  >
    <cent-select
      ref="centselect"
      v-if="centAccontConfig"
      :tabs-type="tabsType"
      @send-type="sendType"
    ></cent-select>
    <el-col
      :lg="8"
      :sm="12"
      :xs="24"
    >
      <div class="label">{{labelTitle}}</div>
      <el-date-picker
        v-if="!realMobile"
        style="width: 100%"
        v-model="date"
        type="daterange"
        value-format="yyyy-MM-dd HH-mm-ss"
        :range-separator="phFileter('root.dateTo')"
        :start-placeholder="phFileter('root.startDate')"
        :end-placeholder="phFileter('root.endDate')"
        @change="toQuery"
      >
      </el-date-picker>
      <select-date-duration
        class="header-sub-item"
        v-model="date"
      ></select-date-duration>
    </el-col>
  </el-row>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { parseTime,init_date } from '@/utils'
export default {
  name: "queryHeader",
  props: {
    labelTitle: {
      type: String,
      default: '',
    },
    centAccontConfig: {
    },
  },
  data() {
    return {
      date: [], // 时间
      tabsType: 'USD'
    }
  },
  watch: {
    /*tabName(newValue, oldValue) {
      //交易历史 平仓时间默认选择近一个月，单次查询不能超过3个月
      if(newValue == 'traderHistory'){

        this.date = [init_date().oneMonAgo,init_date().today];
      }else {
        this.date = [];
      }
    }*/
  },
  computed: {
    ...mapGetters(['realMobile']),
  },
  methods: {
    phFileter(data) {
      return this.$t(data);
    },
    toQuery(){
      this.$emit('toQuery');
    },
    sendType(tabsType){
      this.tabsType = tabsType;
      this.toQuery();
    }
  },
}
</script>

<style lang="scss" scoped>
.query-header {
  .label {
    margin-bottom: 5px;
  }
  .header-sub-item {
    width: 100%;
  }
}
</style>
